export var Global = {
  //url: 'http://localhost:3900/'//Esta es la direccion del backend para desarrollo
  url: 'https://mountsinai.onrender.com/' //Este en el servidor de produccion que es igual para back y front
};
